module.exports = __webpack_public_path__ + "img/31aaaa2.png";